import * as React from 'react';
import Select, {
	SelectValue,
} from '../../../../../Components/Base/Select/Select';
import { useTermItemsQuery } from '../../../../../graphql/graphql';
import { FieldError } from 'react-hook-form';
import { useMemo, useState } from 'react';
import Loading from '../../../../../Components/Loading';
import useTranslation from '../../../../../Hooks/useTranslation';

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	error?: FieldError;
}

const HealthCareReimbursementVzpSelect: React.FC<Props> = props => {
	const { value, onChange } = props;
	const { data, isLoading } = useTermItemsQuery({
		termType: 'health_care_reimbursement_vzp',
		take: 999,
	});
	const [defaultValue, setDefaultValue] = useState(value);
	const { t } = useTranslation();

	const options: SelectValue[] = useMemo(() => {
		const items: SelectValue[] = [];

		for (const termItem of data?.termItems?.data || []) {
			if (termItem) {
				items.push({
					value: termItem.id,
					label: termItem.name || termItem.id || '',
				});
			}
		}

		return items;
	}, [data]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<Select
			options={options}
			{...props}
			onChange={onChange}
			placeholder={t('base.shared.pick')}
			value={defaultValue?.label ? defaultValue : value}
		/>
	);
};

export default HealthCareReimbursementVzpSelect;
